(function () {
  if (window.__rynorPixelsBooted) return;
  window.__rynorPixelsBooted = true;

  var CONFIG = (window.RYNOR_PIXELS && window.RYNOR_PIXELS.context) || {};
  var STATE = {
    cart: null,
    cartPromise: null,
    lastSentAt: {},
    ajaxCartPatched: false
  };

  function now() {
    return Date.now ? Date.now() : new Date().getTime();
  }

  function makeId(prefix) {
    return [prefix || 'event', now(), Math.random().toString(36).slice(2, 10)].join('.');
  }

  function extend(target) {
    target = target || {};
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] || {};
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }

  function isFiniteNumber(value) {
    return typeof value === 'number' && isFinite(value);
  }

  function toMinorUnitsNumber(value) {
    var number = Number(value);
    if (!isFinite(number)) return 0;
    return number;
  }

  function fromMinorUnits(value) {
    return +(toMinorUnitsNumber(value) / 100).toFixed(2);
  }

  function toQuantity(value, fallback) {
    var number = parseInt(value, 10);
    if (!isFinite(number) || number < 0) return fallback || 0;
    return number;
  }

  function dedupe(key, ttl) {
    var last = STATE.lastSentAt[key];
    var timestamp = now();
    if (last && timestamp - last < (ttl || 1200)) {
      return true;
    }
    STATE.lastSentAt[key] = timestamp;
    return false;
  }

  function getCurrency() {
    return CONFIG.currency || CONFIG.shopCurrency || 'USD';
  }

  function normalizeShopifyLineItem(raw, index) {
    raw = raw || {};

    var productId = raw.product_id || raw.productId || (raw.product && raw.product.id) || raw.id || '';
    var variantId = raw.variant_id || raw.variantId || (raw.variant && raw.variant.id) || raw.id || productId || '';
    var title = raw.product_title || raw.productTitle || raw.title || (raw.product && raw.product.title) || raw.item_name || '';
    var variantTitle = raw.variant_title || raw.variantTitle || raw.item_variant || raw.variant || (raw.variant && raw.variant.title) || '';
    var brand = raw.vendor || raw.brand || (raw.product && raw.product.vendor) || raw.item_brand || '';
    var category = raw.product_type || raw.productType || raw.type || (raw.product && raw.product.type) || raw.item_category || '';
    var sku = raw.sku || (raw.variant && raw.variant.sku) || raw.item_sku || '';
    var quantity = toQuantity(raw.quantity, 1);

    if (variantTitle === 'Default Title') variantTitle = '';

    var priceMinor = null;
    if (isFiniteNumber(raw.final_price)) priceMinor = raw.final_price;
    if (priceMinor === null && isFiniteNumber(raw.price)) priceMinor = raw.price;
    if (priceMinor === null && isFiniteNumber(raw.original_price)) priceMinor = raw.original_price;
    if (priceMinor === null && isFiniteNumber(raw.line_price) && quantity > 0) priceMinor = raw.line_price / quantity;
    if (priceMinor === null && isFiniteNumber(raw.product_price)) priceMinor = Math.round(raw.product_price * 100);
    if (priceMinor === null) priceMinor = 0;

    var itemId = String(variantId || productId || '');

    return {
      id: itemId,
      item_id: itemId,
      item_name: title,
      item_brand: brand,
      item_category: category,
      item_variant: variantTitle,
      item_sku: sku,
      product_id: String(productId || ''),
      variant_id: String(variantId || ''),
      price: fromMinorUnits(priceMinor),
      quantity: quantity,
      index: typeof index === 'number' ? index : 0,
      google_business_vertical: 'retail'
    };
  }

  function normalizeProduct(product, variant, index) {
    product = product || {};
    variant = variant || {};

    var variantTitle = variant.title || '';
    if (variantTitle === 'Default Title') variantTitle = '';

    var itemId = String(variant.id || product.id || '');

    return {
      id: itemId,
      item_id: itemId,
      item_name: product.title || '',
      item_brand: product.vendor || '',
      item_category: product.type || '',
      item_variant: variantTitle,
      item_sku: variant.sku || '',
      product_id: String(product.id || ''),
      variant_id: String(variant.id || product.id || ''),
      price: fromMinorUnits(variant.price || product.price || 0),
      quantity: 1,
      index: typeof index === 'number' ? index : 0,
      google_business_vertical: 'retail'
    };
  }

  function normalizeListingCard(card, index) {
    if (!card) return null;

    var productId = card.getAttribute('data-product-id') || '';
    var title = card.getAttribute('data-alpha') || '';
    var priceMinor = toMinorUnitsNumber(card.getAttribute('data-price'));

    if (!productId && !title) return null;

    return {
      id: String(productId || ''),
      item_id: String(productId || ''),
      item_name: title,
      price: fromMinorUnits(priceMinor),
      quantity: 1,
      index: typeof index === 'number' ? index : 0,
      google_business_vertical: 'retail'
    };
  }

  function buildPayload(items, extra) {
    extra = extra || {};
    items = (items || []).filter(Boolean);

    var payload = {
      currency: typeof extra.currency === 'string' && extra.currency ? extra.currency : getCurrency(),
      items: items,
      content_ids: items.map(function (item) {
        return item.id || item.item_id || '';
      }).filter(Boolean),
      contents: items.map(function (item) {
        return {
          id: item.id || item.item_id || '',
          quantity: toQuantity(item.quantity, 1),
          item_price: isFiniteNumber(item.price) ? item.price : 0
        };
      }),
      content_type: 'product'
    };

    payload.value = isFiniteNumber(extra.value)
      ? +extra.value.toFixed(2)
      : +items.reduce(function (sum, item) {
          return sum + ((Number(item.price) || 0) * (toQuantity(item.quantity, 1) || 0));
        }, 0).toFixed(2);

    payload.num_items = items.reduce(function (sum, item) {
      return sum + (toQuantity(item.quantity, 1) || 0);
    }, 0);

    for (var key in extra) {
      if (Object.prototype.hasOwnProperty.call(extra, key) && typeof extra[key] !== 'undefined') {
        payload[key] = extra[key];
      }
    }

    payload.items = items;
    return payload;
  }

  function pushDataLayer(name, payload, eventId) {
    window.dataLayer = window.dataLayer || [];

    try {
      window.dataLayer.push({ ecommerce: null });
    } catch (error) {
      // no-op
    }

    try {
      window.dataLayer.push(extend({
        event: name,
        ecommerce: payload,
        event_id: eventId,
        page_type: CONFIG.pageType || '',
        template_name: CONFIG.template || ''
      }, payload));
    } catch (error) {
      // no-op
    }
  }

  function pushGoogleTag(name, payload) {
    if (typeof window.gtag !== 'function') return;

    try {
      window.gtag('event', name, extend({ transport_type: 'beacon' }, payload));
    } catch (error) {
      // no-op
    }
  }

  function getPageUrl() {
    try {
      return window.location.href;
    } catch (error) {
      return '';
    }
  }

  function normalizeDestinationContents(payload) {
    return (payload && payload.contents || []).map(function (item) {
      return {
        id: item && item.id ? item.id : '',
        quantity: toQuantity(item && item.quantity, 1),
        item_price: Number(item && item.item_price) || 0
      };
    }).filter(function (item) {
      return item.id;
    });
  }

  function buildMetaParams(payload) {
    payload = payload || {};
    var firstItem = payload.items && payload.items[0] ? payload.items[0] : {};
    var params = {
      content_type: payload.content_type || 'product',
      content_ids: payload.content_ids || [],
      contents: normalizeDestinationContents(payload),
      currency: payload.currency || getCurrency(),
      value: isFiniteNumber(payload.value) ? payload.value : 0
    };

    if (payload.search_term) params.search_string = payload.search_term;
    if (payload.num_items) params.num_items = payload.num_items;
    if (firstItem.item_name) params.content_name = firstItem.item_name;
    if (firstItem.item_category) params.content_category = firstItem.item_category;

    return params;
  }

  function buildTikTokParams(payload, eventId) {
    payload = payload || {};
    var firstItem = payload.items && payload.items[0] ? payload.items[0] : {};
    var params = {
      content_type: payload.content_type || 'product',
      content_ids: payload.content_ids || [],
      currency: payload.currency || getCurrency(),
      value: isFiniteNumber(payload.value) ? payload.value : 0,
      quantity: payload.num_items || 1,
      description: firstItem.item_name || document.title || '',
      event_id: eventId
    };

    if (payload.search_term) params.search_string = payload.search_term;
    return params;
  }

  function buildSnapParams(payload, eventId) {
    payload = payload || {};
    var firstItem = payload.items && payload.items[0] ? payload.items[0] : {};
    var params = {
      item_ids: payload.content_ids || [],
      currency: payload.currency || getCurrency(),
      price: isFiniteNumber(payload.value) ? payload.value : 0,
      number_items: payload.num_items || 1,
      description: firstItem.item_name || document.title || '',
      client_dedup_id: eventId,
      event_id: eventId
    };

    if (firstItem.item_category) params.item_category = firstItem.item_category;
    if (payload.search_term) params.search_string = payload.search_term;

    return params;
  }

  function sendMetaEvent(name, payload, eventId) {
    // Standard events (PageView, ViewContent, AddToCart, InitiateCheckout, Search)
    // are sent by the Shopify Facebook & Instagram app with proper dedup IDs.
    // Only send custom events here so nothing is double-counted.
    var customEvents = {
      view_cart: 'ViewCart',
      remove_from_cart: 'RemoveFromCart',
      view_item_list: 'ViewItemList'
    };

    var eventName = customEvents[name];
    if (!eventName) return 'unsupported';
    if (typeof window.fbq !== 'function') return 'unavailable';

    try {
      window.fbq('trackCustom', eventName, buildMetaParams(payload), { eventID: eventId });
      return 'sent';
    } catch (error) {
      return 'failed';
    }
  }

  function sendTikTokEvent(name, payload, eventId) {
    if (!window.ttq || typeof window.ttq.track !== 'function') return 'unavailable';

    var eventName = null;

    switch (name) {
      case 'view_item':
        eventName = 'ViewContent';
        break;
      case 'add_to_cart':
        eventName = 'AddToCart';
        break;
      case 'begin_checkout':
        eventName = 'InitiateCheckout';
        break;
      case 'search':
      case 'view_search_results':
        eventName = 'Search';
        break;
      default:
        return 'unsupported';
    }

    try {
      window.ttq.track(eventName, buildTikTokParams(payload, eventId));
      return 'sent';
    } catch (error) {
      return 'failed';
    }
  }

  function sendSnapEvent(name, payload, eventId) {
    if (typeof window.snaptr !== 'function') return 'unavailable';

    var eventName = null;

    switch (name) {
      case 'page_view':
        eventName = 'PAGE_VIEW';
        break;
      case 'view_item':
        eventName = 'VIEW_CONTENT';
        break;
      case 'add_to_cart':
        eventName = 'ADD_CART';
        break;
      case 'begin_checkout':
        eventName = 'START_CHECKOUT';
        break;
      case 'search':
      case 'view_search_results':
        eventName = 'SEARCH';
        break;
      default:
        return 'unsupported';
    }

    try {
      window.snaptr('track', eventName, buildSnapParams(payload, eventId));
      return 'sent';
    } catch (error) {
      return 'failed';
    }
  }

  function queueDestinationEvent(name, payload, eventId, targets) {
    if (!targets.meta && !targets.tiktok && !targets.snap) return;

    STATE.pendingDestinationEvents = STATE.pendingDestinationEvents || [];

    STATE.pendingDestinationEvents.push({
      name: name,
      payload: payload,
      eventId: eventId,
      targets: targets,
      createdAt: now()
    });
  }

  function dispatchDestinationPixels(name, payload, eventId) {
    var metaStatus = sendMetaEvent(name, payload, eventId);
    var tikTokStatus = sendTikTokEvent(name, payload, eventId);
    var snapStatus = sendSnapEvent(name, payload, eventId);

    queueDestinationEvent(name, payload, eventId, {
      meta: metaStatus === 'unavailable',
      tiktok: tikTokStatus === 'unavailable',
      snap: snapStatus === 'unavailable'
    });
  }

  function flushDestinationQueue() {
    var queue = STATE.pendingDestinationEvents || [];
    if (!queue.length) return;

    STATE.pendingDestinationEvents = queue.filter(function (entry) {
      if (entry.targets.meta) {
        var metaStatus = sendMetaEvent(entry.name, entry.payload, entry.eventId);
        entry.targets.meta = metaStatus === 'unavailable';
      }

      if (entry.targets.tiktok) {
        var tikTokStatus = sendTikTokEvent(entry.name, entry.payload, entry.eventId);
        entry.targets.tiktok = tikTokStatus === 'unavailable';
      }

      if (entry.targets.snap) {
        var snapStatus = sendSnapEvent(entry.name, entry.payload, entry.eventId);
        entry.targets.snap = snapStatus === 'unavailable';
      }

      var stillWaiting = entry.targets.meta || entry.targets.tiktok || entry.targets.snap;
      var tooOld = now() - entry.createdAt > 10000;
      return stillWaiting && !tooOld;
    });
  }

  function announceDestinationOnly(name, payload, meta) {
    meta = meta || {};
    var eventId = meta.eventId || makeId(name);
    var finalPayload = extend({}, payload, { event_id: eventId });
    dispatchDestinationPixels(name, finalPayload, eventId);
  }

  function announce(name, payload, meta) {

    meta = meta || {};

    var eventId = meta.eventId || makeId(name);
    var finalPayload = extend({}, payload, { event_id: eventId });

    pushDataLayer(name, finalPayload, eventId);
    pushGoogleTag(name, finalPayload);
    dispatchDestinationPixels(name, finalPayload, eventId);

    try {
      document.dispatchEvent(new CustomEvent('rynor:ecommerce', {
        detail: {
          name: name,
          payload: finalPayload,
          eventId: eventId,
          source: meta.source || 'theme'
        }
      }));
    } catch (error) {
      // no-op
    }
  }

  function setCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return cart;
    STATE.cart = cart;
    return cart;
  }

  function fetchCart() {
    if (STATE.cartPromise) return STATE.cartPromise;

    STATE.cartPromise = window.fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to fetch cart');
      return response.json();
    }).then(function (cart) {
      return setCart(cart);
    }).catch(function () {
      return STATE.cart;
    }).finally(function () {
      STATE.cartPromise = null;
    });

    return STATE.cartPromise;
  }

  function getCart() {
    return STATE.cart ? Promise.resolve(STATE.cart) : fetchCart();
  }

  function cartToPayload(cart) {
    cart = cart || { items: [] };
    return buildPayload((cart.items || []).map(normalizeShopifyLineItem), {
      value: fromMinorUnits(isFiniteNumber(cart.items_subtotal_price) ? cart.items_subtotal_price : cart.total_price || 0)
    });
  }

  function indexCartItems(cart) {
    var map = {};
    (cart && cart.items || []).forEach(function (item) {
      var key = item.key || item.variant_id || item.id;
      if (!key) return;
      map[String(key)] = item;
    });
    return map;
  }

  function diffCart(before, after) {
    var previous = indexCartItems(before || { items: [] });
    var next = indexCartItems(after || { items: [] });
    var allKeys = {};
    var key;

    for (key in previous) allKeys[key] = true;
    for (key in next) allKeys[key] = true;

    var changes = [];

    for (key in allKeys) {
      var oldItem = previous[key];
      var newItem = next[key];
      var oldQty = toQuantity(oldItem && oldItem.quantity, 0);
      var newQty = toQuantity(newItem && newItem.quantity, 0);
      var delta = newQty - oldQty;

      if (delta === 0) continue;

      if (delta > 0) {
        changes.push({
          type: 'add_to_cart',
          item: extend({}, newItem || oldItem, { quantity: delta })
        });
      } else {
        changes.push({
          type: 'remove_from_cart',
          item: extend({}, oldItem || newItem, { quantity: Math.abs(delta) })
        });
      }
    }

    return changes;
  }

  function handleAddToCartResponse(data, source) {
    var items = (Array.isArray(data) ? data : [data]).map(normalizeShopifyLineItem).filter(Boolean);
    if (!items.length) return;

    var payload = buildPayload(items);
    var dedupeKey = [
      'add_to_cart',
      payload.content_ids.join(','),
      payload.value,
      payload.num_items
    ].join('|');

    if (dedupe(dedupeKey, 700)) return;

    announce('add_to_cart', payload, { source: source || 'cart_add' });
  }

  function handleCartMutation(before, after, source) {
    var changes = diffCart(before, after);

    changes.forEach(function (change) {
      var item = normalizeShopifyLineItem(change.item, 0);
      var payload = buildPayload([item]);
      var dedupeKey = [
        change.type,
        payload.content_ids.join(','),
        payload.value,
        payload.num_items,
        source || 'cart_change'
      ].join('|');

      if (dedupe(dedupeKey, 700)) return;

      announce(change.type, payload, { source: source || 'cart_change' });
    });
  }

  function isCartUrl(url, path) {
    if (!url) return false;
    return url.indexOf(path) !== -1;
  }

  function installFetchTracking() {
    if (!window.fetch) return;

    var originalFetch = window.fetch;

    window.fetch = function () {
      var args = arguments;
      var input = args[0];
      var init = args[1] || {};
      var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');

      var needsBeforeCart = isCartUrl(url, '/cart/change.js') || isCartUrl(url, '/cart/update.js') || isCartUrl(url, '/cart/clear.js');
      var beforeCartPromise = needsBeforeCart ? getCart().catch(function () { return null; }) : Promise.resolve(null);

      return originalFetch.apply(this, args).then(function (response) {
        if (!response || !response.ok || !url) return response;

        if (isCartUrl(url, '/cart/add.js')) {
          response.clone().json().then(function (data) {
            handleAddToCartResponse(data, 'cart_add_fetch');
            fetchCart();
          }).catch(function () {
            fetchCart();
          });
          return response;
        }

        if (isCartUrl(url, '/cart/change.js') || isCartUrl(url, '/cart/update.js') || isCartUrl(url, '/cart/clear.js')) {
          Promise.all([
            beforeCartPromise,
            response.clone().json().catch(function () { return null; })
          ]).then(function (result) {
            var beforeCart = result[0];
            var afterCart = result[1];
            if (afterCart && Array.isArray(afterCart.items)) {
              handleCartMutation(beforeCart, afterCart, 'cart_change_fetch');
              setCart(afterCart);
            } else {
              fetchCart();
            }
          }).catch(function () {
            fetchCart();
          });
          return response;
        }

        if (isCartUrl(url, '/cart.js')) {
          response.clone().json().then(function (cart) {
            setCart(cart);
          }).catch(function () {
            // no-op
          });
        }

        return response;
      });
    };
  }

  function emitViewCart(source) {
    return getCart().then(function (cart) {
      if (!cart || !Array.isArray(cart.items) || !cart.items.length) return;

      var payload = cartToPayload(cart);
      var dedupeKey = [
        'view_cart',
        cart.token || '',
        payload.value,
        payload.num_items
      ].join('|');

      if (dedupe(dedupeKey, 1200)) return;

      announce('view_cart', payload, { source: source || 'cart_view' });
    });
  }

  function emitBeginCheckout(source) {
    if (!STATE.cart || !Array.isArray(STATE.cart.items) || !STATE.cart.items.length) return;

    var payload = cartToPayload(STATE.cart);
    var dedupeKey = [
      'begin_checkout',
      STATE.cart.token || '',
      payload.value,
      payload.num_items
    ].join('|');

    if (dedupe(dedupeKey, 1500)) return;

    announce('begin_checkout', payload, { source: source || 'checkout_click' });
  }

  function getVisibleProductJson() {
    var scripts = document.querySelectorAll('.product-page .product-json, [data-section-type="product"] .product-json, .product-json');

    for (var i = 0; i < scripts.length; i++) {
      var script = scripts[i];
      var host = script.closest ? script.closest('.product-page, [data-section-type="product"], [data-product-id]') : null;
      if (host && host.offsetParent === null && host !== document.body) continue;

      try {
        var data = JSON.parse(script.textContent || script.innerHTML || '{}');
        if (data && data.id) return data;
      } catch (error) {
        // try next script
      }
    }

    return null;
  }

  function getSelectedVariant(product) {
    var selectedId = null;
    var variantInput = document.querySelector('#formVariantId');

    if (variantInput && variantInput.value) {
      selectedId = String(variantInput.value);
    }

    if (selectedId && Array.isArray(product.variants)) {
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === selectedId) {
          return product.variants[i];
        }
      }
    }

    if (Array.isArray(product.variants) && product.variants.length) {
      for (var j = 0; j < product.variants.length; j++) {
        if (product.variants[j].available) return product.variants[j];
      }
      return product.variants[0];
    }

    return null;
  }

  function emitViewItem() {
    if (CONFIG.pageType !== 'product') return;

    var product = getVisibleProductJson();
    if (!product) return;

    var variant = getSelectedVariant(product);
    var item = normalizeProduct(product, variant, 0);
    var payload = buildPayload([item]);
    var dedupeKey = ['view_item', item.id || item.item_id, payload.value].join('|');

    if (dedupe(dedupeKey, 900)) return;

    announce('view_item', payload, { source: 'product_page' });
  }

  function getListingItems(limit) {
    var cards = Array.prototype.slice.call(document.querySelectorAll('article[data-card]')).slice(0, limit || 12);
    return cards.map(normalizeListingCard).filter(Boolean);
  }

  function emitListingEvents() {
    var items = getListingItems(12);
    if (!items.length) return;

    var listName = (document.title || '').trim();

    if (CONFIG.pageType === 'collection') {
      var listPayload = buildPayload(items, { item_list_name: listName });
      var listKey = ['view_item_list', items.map(function (item) { return item.item_id; }).join(',')].join('|');
      if (!dedupe(listKey, 2500)) {
        announce('view_item_list', listPayload, { source: 'collection_page' });
      }
      return;
    }

    if (CONFIG.pageType === 'search') {
      var searchTerm = '';
      try {
        searchTerm = new URLSearchParams(window.location.search).get('q') || '';
      } catch (error) {
        searchTerm = '';
      }

      if (searchTerm && !dedupe(['search', searchTerm].join('|'), 2500)) {
        announce('search', { search_term: searchTerm }, { source: 'search_page' });
      }

      if (!dedupe(['view_search_results', searchTerm, items.map(function (item) { return item.item_id; }).join(',')].join('|'), 2500)) {
        announce('view_search_results', buildPayload(items, {
          item_list_name: listName,
          search_term: searchTerm
        }), { source: 'search_page' });
      }
    }
  }

  function patchAjaxCartOpeners() {
    if (STATE.ajaxCartPatched || !window.WAU || !window.WAU.AjaxCart) return;

    ['showDrawer', 'showModal'].forEach(function (methodName) {
      var original = window.WAU.AjaxCart[methodName];
      if (typeof original !== 'function') return;

      window.WAU.AjaxCart[methodName] = function () {
        var result = original.apply(this, arguments);
        setTimeout(function () {
          emitViewCart(methodName);
        }, 150);
        return result;
      };
    });

    STATE.ajaxCartPatched = true;
  }

  function bindGlobalListeners() {
    document.addEventListener('cart:open', function () {
      emitViewCart('cart_open_event');
    });

    document.addEventListener('ajaxCart:open', function () {
      emitViewCart('ajax_cart_open_event');
    });

    document.addEventListener('click', function (event) {
      var checkoutTrigger = event.target.closest('button[name="checkout"], a[href*="/checkout"], button#checkout, a#checkout, .shopify-payment-button__button');
      if (!checkoutTrigger) return;
      emitBeginCheckout('checkout_click');
    }, true);

    document.addEventListener('change', function (event) {
      if (CONFIG.pageType !== 'product') return;
      if (!event.target.closest('#formVariantId, .js-variant-selector, [data-product-form]')) return;
      setTimeout(emitViewItem, 50);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches) return;
      if (!form.matches('form[action*="/cart"]')) return;
      if (!form.querySelector('[name="checkout"]')) return;
      emitBeginCheckout('checkout_submit');
    }, true);
  }

  function boot() {
    installFetchTracking();
    bindGlobalListeners();
    patchAjaxCartOpeners();
    fetchCart();

    announceDestinationOnly('page_view', {
      page_location: getPageUrl(),
      page_path: window.location && window.location.pathname ? window.location.pathname : '',
      page_title: document.title || '',
      currency: getCurrency()
    }, { source: 'page_load' });

    if (CONFIG.pageType === 'product') {
      setTimeout(emitViewItem, 50);
    }

    if (CONFIG.pageType === 'collection' || CONFIG.pageType === 'search') {
      setTimeout(emitListingEvents, 50);
    }

    if (CONFIG.pageType === 'cart') {
      setTimeout(function () {
        emitViewCart('cart_page');
      }, 100);
    }

    var patchTimer = setInterval(function () {
      patchAjaxCartOpeners();
      if (STATE.ajaxCartPatched) {
        clearInterval(patchTimer);
      }
    }, 400);

    setTimeout(function () {
      clearInterval(patchTimer);
    }, 6000);

    var destinationTimer = setInterval(function () {
      flushDestinationQueue();
      if (!STATE.pendingDestinationEvents || !STATE.pendingDestinationEvents.length) {
        clearInterval(destinationTimer);
      }
    }, 400);

    window.addEventListener('load', flushDestinationQueue, { once: true });

    setTimeout(function () {
      clearInterval(destinationTimer);
      flushDestinationQueue();
    }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
